import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import {Link} from 'react-router-dom'
import './index.css'

class GamingRoute extends Component {
  state = {
    gamingVideos: [],
    apiStatus: 'INITIAL',
  }

  componentDidMount() {
    this.getGamingVideos()
  }

  getGamingVideos = async () => {
    this.setState({apiStatus: 'IN_PROGRESS'})
    const jwtToken = Cookies.get('jwt_token')
    const url = 'https://apis.ccbp.in/videos/gaming'
    const options = {
      method: 'GET',
      headers: {Authorization: `Bearer ${jwtToken}`},
    }

    try {
      const response = await fetch(url, options)
      if (response.ok) {
        const data = await response.json()
        const updated = data.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          viewCount: each.view_count,
        }))
        this.setState({gamingVideos: updated, apiStatus: 'SUCCESS'})
      } else {
        this.setState({apiStatus: 'FAILURE'})
      }
    } catch {
      this.setState({apiStatus: 'FAILURE'})
    }
  }

  renderGamingVideos = () => {
    const {gamingVideos} = this.state
    return (
      <ul className="videos-list">
        {gamingVideos.map(each => (
          <li key={each.id} className="video-card">
            <Link to={`/videos/${each.id}`} className="video-link">
              <img
                src={each.thumbnailUrl}
                alt="video thumbnail"
                className="thumbnail"
              />
              <p className="title">{each.title}</p>
              <p>{each.viewCount} Watching Worldwide</p>
            </Link>
          </li>
        ))}
      </ul>
    )
  }

  renderLoader = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#0b69ff" height={50} width={50} />
    </div>
  )

  render() {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case 'IN_PROGRESS':
        return this.renderLoader()
      case 'SUCCESS':
        return this.renderGamingVideos()
      case 'FAILURE':
        return <p>Failed to load gaming videos</p>
      default:
        return null
    }
  }
}

export default GamingRoute
